import { NavigationGuard } from "vue-router";
import { productFruits } from "product-fruits";

export const ProductFruitsGuard: NavigationGuard = async (to, from, next) => {
  productFruits.safeExec(($productFruits) => {
    return $productFruits.push(["pageChanged"]);
  });
  return next();
};
